<template>
   <div id="homeContent" >
     <div v-if="settings" class="row dashboard">
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-info">
              <div class="inner">
                <h4>{{settings.publishersCount}}</h4>

                <p>تعداد ناشر ها </p>
              </div>
              <div class="icon">
                <i class="fa fa-user"></i>
              </div>
              <router-link to="/admin/publisher" class="small-box-footer">اطلاعات بیشتر <i class="fa fa-arrow-circle-left"></i></router-link>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-success">
              <div class="inner">
                <h4>{{settings.authorsCount}}</h4>

                <p> تعداد نویسنده ها</p>
              </div>
              <div class="icon">
                <i class="fa fa-pen-nib"></i>
              </div>
              <router-link to="/admin/author" class="small-box-footer">اطلاعات بیشتر <i class="fa fa-arrow-circle-left"></i></router-link>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-warning">
              <div class="inner">
                <h4>{{settings.booksCount}}</h4>

                <p>کتاب های ثبت شده</p>
              </div>
              <div class="icon">
                <i class="fa fa-book"></i>
              </div>
              <router-link to="/admin/books" class="small-box-footer">اطلاعات بیشتر <i class="fa fa-arrow-circle-left"></i></router-link>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h4>{{settings.commentsCount }}</h4>

                <p>تعداد کامنت ها</p>
              </div>
              <div class="icon">
                <i class="fa fa-comment"></i>
              </div>
              <router-link to="/admin/comments" class="small-box-footer">اطلاعات بیشتر <i class="fa fa-arrow-circle-left"></i></router-link>
            </div>
          </div>
          <!-- ./col -->
        </div>
    </div>
</template>
<style>
.dashboard{
  margin-right:250px ;
}
#homeContent{
  z-index:1
}
</style>
<script>
export default {  metaInfo() {
    return {
      title: " داشبورد",
    }
  },
      data() {
    return {
      settings: null
    };
  },
   mounted() {
    this.$axios.get("/admin/dashboard").then((res) => {
      this.settings = res.data.data;
    });
  }
}
</script>